<template lang="">
  <div class="container">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
    <!-- 企业代号 -->
      <FormItem label="企业代号" prop="clientcode">
        <Input
          @click="SelectClientSwitch = !SelectClientSwitch"
          v-model="formValidate.clientcode"
          placeholder="请输入4位数代号"
          style="width: 200px"
        ></Input>
      </FormItem>
      <!-- 企业名称 -->
      <FormItem label="生码批号" prop="batch">
        <Input
          v-model="formValidate.batch"
          placeholder="请输入生码批号"
          style="width: 300px"
        ></Input>
      </FormItem>


      <!-- 套标 -->
      <FormItem label="启用套标" prop="tag">
          <i-switch v-model="formValidate.tag" size="large">
            <template #open>
              <span>是</span>
            </template>
            <template #close>
              <span>否</span>
            </template>
          </i-switch>
      </FormItem>

      <!-- 套标 -->
      <FormItem label="设置套标" prop="account" v-if="formValidate.tag">
        <Input
          disabled
          v-model="formValidate.maxTag"
          placeholder="大标数量"
          style="width: 100px"
        ></Input>
        -
        <Input
          v-model="formValidate.minTag"
          placeholder="小标数量"
          style="width: 100px"
        ></Input>
      </FormItem>

      <!-- 流水号范围 -->
      <FormItem label="流水号范围" prop="account">
        <Input
          v-model="formValidate.startSerial"
          placeholder="开始流水号"
          style="width: 200px"
        ></Input>
        -
        <Input
          disabled
          v-model="formValidate.endSerial"
          placeholder="结束流水号"
          style="width: 200px"
        ></Input>
      </FormItem>

      <!-- 数量 -->
      <FormItem label="数量" prop="number">
        <Input
          v-model="number"
          placeholder="请设置数量"
          width="200"
          style="width: 200px"
        ></Input>
        &nbsp;<span v-if="(number % (maxTag + minTag)) != 0" style="color:red;">*请输入正确的数量</span>
      </FormItem>
      <!-- 前缀 -->
      <FormItem label="生码前缀" prop="prefix">
        <Input
          v-model="formValidate.prefix"
          placeholder="请输入前缀"
          width="400"
          style="width: 200px"
        ></Input>
      </FormItem>
      <!-- 启用状态 -->
      <FormItem label="启用" prop="state">
        <RadioGroup v-model="formValidate.state">
          <Radio label="是" border></Radio>
          <Radio label="否" border></Radio>
        </RadioGroup>
      </FormItem>
      <!-- 备注 -->
      <FormItem label="备注" prop="remark">
        <Input
          v-model="formValidate.remark"
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
          placeholder="备注信息..."
        ></Input>
      </FormItem>
      <!-- 添加按钮 -->
      <FormItem>
        <Button type="primary" @click="handleSubmit('formValidate')"
          >确认添加</Button
        >
      </FormItem>
    </Form>

    <SelectClient v-if="SelectClientSwitch" @Value="SelectClientVal" @close="SelectClientClose"></SelectClient>

  </div>
</template>
<script>
import { NewCodeList, GetClients, GetClientSerial } from "@/api/index";
import SelectClient from "@/views/selectClient";
export default {
  data() {
    return {
      clientObj: {},
      formValidate: {
        tag: false,
        maxTag: 1,
        minTag: 1,
        // 企业编号
        clientcode: "",
        // 批号
        batch: "",
        // 开始流水号
        startSerial: "",
        // 结束流水号
        endSerial: "",
        // 企业名称
        name: "",
        // 企业账号
        account: "",
        // 启用状态
        state: "是",
        // 备注
        remark: "",
        // 前缀
        prefix: "",
      },
      // 数量
      number: "",
      ruleValidate: {
        code: [
          { required: true, message: "请输入企业代号", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "企业号最少需要 4 位数",
            trigger: "blur",
          },
        ],
      },
      SelectClientSwitch: false
    };
  },
  watch: {
    number(newVal, oldVal) {
      this.formValidate.endSerial = Number(this.formValidate.startSerial) + (newVal - 1)
    },
  },
  mounted() {
    GetClients({}).then((res) => {
      this.clientObj = res
    });
  },
  components: {
    SelectClient
  },
  methods: {
    // 关闭选择框
    SelectClientClose() {
      this.SelectClientSwitch = false
    },
    // 获取数据
    SelectClientVal(value) {
      this.formValidate.clientcode = value
      this.SelectClientSwitch = false;

      GetClientSerial({
        code: value
      }).then(res => {
        this.formValidate.startSerial = res.data
      })
    },
    NewCode() {
      NewCodeList({
        // 企业编号
        clientcode: this.formValidate.clientcode,
        // 批号
        batch: this.formValidate.batch,
        // 数量
        number: this.number,
        // 开始流水号
        startSerial: this.formValidate.startSerial,
        // 结束流水号
        endSerial: this.formValidate.endSerial,
        // 企业名称
        name: this.formValidate.name,
        // 企业账号
        account: this.formValidate.account,
        // 启用状态
        state: this.formValidate.state,
        // 备注
        remark: this.formValidate.remark,
        // 前缀
        prefix: this.formValidate.prefix,
        // 小标数量
        minTag: this.formValidate.minTag,
      }).then((res) => {
        if (res.success == true) {
          this.$Notice.success({ title: '添加成功' });
          this.$emit('close', '')
        } else {
          this.$Notice.error({ title: res.msg });
        }
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.NewCode();
          // this.$Message.success('Success!');
        } else {
          this.$Message.error("请填写完整!");
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
  },
};
</script>
<style scoped>
.container {
  width: 100%;
}
</style>
